<template>
  <ElAlert effect="dark" show-icon type="warning">
    {{ $t('ADVERTISEMENT.CAMPAIGN_VIEW.ADD_KEYWORD_HINT_DESCRIPTION') }}
    <RouterLink
      v-if="!isOnCampaignKeywordsRoute"
      :to="{ name: 'search-ads-campaign-bids' }"
    >
      {{ $t('ADVERTISEMENT.ADD_BID') }}
    </RouterLink>
  </ElAlert>
</template>

<script>
export default {
  name: 'CampaignViewAddKeywordHint',
  computed: {
    isOnCampaignKeywordsRoute() {
      return this.$route.name === 'search-ads-campaign-bids';
    },
  },
};
</script>
